// src/hooks/useConnectionStatus.ts
import { useState, useEffect } from 'react'
import { toast } from 'sonner'
import axios from 'axios'
import { useTranslation } from 'react-i18next'

const testConnectivity = async () => {
  try {
    await axios.get('https://www.google.com', { timeout: 5000 })
    return true
  } catch (error) {
    return false
  }
}

export const useConnectionStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine) // Set initial state based on the current online status
  const { t } = useTranslation()

  useEffect(() => {
    const updateStatus = async () => {
      const isConnected = await testConnectivity()
      setIsOnline(isConnected)
      if (isConnected) {
        //console.log(t('connectionStatus.online'))
        toast.success(t('connectionStatus.restored'))
      } else {
        //console.log(t('connectionStatus.offline'))
        toast.error(t('connectionStatus.lost'))
      }
    }

    const handleOnline = () => {
      if (!isOnline) updateStatus()
    }

    const handleOffline = () => {
      if (isOnline) updateStatus()
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [isOnline, t])

  return isOnline
}
